<template>
  <div>
    <table
      v-for="(it , index) in chunkItems"
      :key="index+'tt'"
      class="left TB_COLLAPSE"
      :class="[cloce]"
      width="12.5%"
    >
      <thead>
        <th width="45%">{{tableHead[index]}}</th>
        <th width="55%">賠率占成</th>
      </thead>
      <tbody>
        <tr
          v-for="(item, key) in it"
          :key="key+'tc'"
          class="tc"
          :class="[checkRankingColor(item, index)]"
        >
          <th :class="item.colour">
            <h4>{{ item.name }}</h4>
          </th>
          <td :class="{'isstop0': item.isstop == 2 || item.isstop == 0 }">
            <table-adjust-odds
              :table="item"
              @go_live_show_bridge="go_live_show_bridge"
              :addbetcal="false"
            ></table-adjust-odds>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { Utile } from "utils";
import { mapGetters, mapState, mapActions } from "vuex";
import checkpath from "./mixins/checkPath.js";
import liveshowSixmark from '@/mixins/liveshow-sixmark.js'
export default {
  name: "liveshow-rawcontact",
  mixins: [checkpath, liveshowSixmark],
  data () {
    return {
      items: [],
      tableHead: [
        "二肖连中",
        "二肖连不中",
        "三肖连中",
        "三肖连不中",
        "四肖连中",
        "四肖连不中",
        "五肖连中",
        "五肖连不中"
      ]
    };
  },
  computed: {
    ...mapGetters(["getliveshow", "getgameid"]),
    KeyName () {
      return this.liveshowPath ? "supododtwo" : "linksupododtwo";
    },
    sortItems () {
      if (!this.chunkItems.length) return []
      return this.chunkItems.slice().map(it => it.slice().sort((a, b) => b.ltl - a.ltl).slice(0, 3).map(it => `${it.odddtl}-${it.troddid}`))
    },
    chunkItems () {
      if (!this.items.length) return []
      return Utile.chunk(this.items, 12);
    }
  },
  watch: {
    "getliveshow.chgbaco" (val) {
      this.getItems();
    },
    "$route.query.page" (val) {
      this.getItems();
    }
  },
  created () {
    this.getItems();
  },
  methods: {
    checkRankingColor (val, key) {
      if (!this.sortItems.length || this.getBettingStatus == 0) return
      const state = this.sortItems[key].some(it => it == `${val.odddtl}-${val.troddid}`)
      return { 'ranking-top': state }
    },
    //getItems() 先预设 scode_1_api 再去判断 盘口 切换时 更换api
    async getItems () {
      try {
        const meta = this.$route.meta
        const obj = {
          gameid: this.getgameid,
          page: meta.page,
          odd: meta.odd,
          baco: this.getliveshow.chgbaco,
          site: this.getliveshow.siteSelect
        }
        if (this.getliveshow.siteSelect == '') {
          this.items = []
          return
        }
        const res = await this.$axios.liveshow[this.KeyName](obj);
        if ('status' in res && res.status === 0) return
        this.IsstopColor(res)
        const array = res.map(it => (it.clas = 1, it));
        this.items = array
      } catch (error) {
        this.$Message.error("網路異常:(S3012)");
      }
    },
    readyaxiso () {
      if (!this.$route.name.includes('rawcontact')) return
      this.getItems();
    },
    go_live_show_bridge () {
      this.$emit("refresh");
    }
  }
};
</script>